module.exports = __webpack_public_path__ + "img/c2b04a561096f8725cd2f84bfa359ab1.png";